export default props => (
  <div className='app-content'>{props.children}</div>
)
